import React from "react";
import ModernContentEditor from "./ModernContentEditor";

const ContentItem = () => {
  return <ModernContentEditor />;
};

export default ContentItem;